import {
  Flex,
  Text,
  Box,
  Image,
  Button,
  Center,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import FormikInput from "../../components/formikinput";
import useCreateNewPassword from "../../api/mutations/useCreateNewPassword";

const CreateNewPassword = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Support both: location.state (OTP flow) and URL query params (email link flow)
  const token = location.state?.token || searchParams.get("token") || "";

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("New password cannot be empty"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Please confirm your new password"),
    }),
    onSubmit: (values) => {
      handleCreateNewPassword(values);
    },
  });

  const createNewPasswordMutation = useCreateNewPassword({
    onSuccess: (res) => {
      if (res.status === 200) {
        toast({
          title: "Password updated successfully!",
          description: "You can now log in using your new password.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        navigate("/");
      }
    },
    onError: (err) => {
      const response = err.response;
      toast({
        title: "Password update failed.",
        description:
          response?.data?.message ||
          "Something went wrong. Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    },
  });

  const handleCreateNewPassword = async (values) => {
    try {
      const data = {
        token: token,
        password: values?.confirmPassword,
      };
      createNewPasswordMutation.mutate(data);
    } catch (e) {
      toast({
        title: "Something went wrong",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex>
      <Box flex={1} bg={"black"}>
        <Center height={"100vh"}>
          <Flex
            alignItems={"center"}
            direction={"column"}
            bg={"grey.400"}
            w={"462px"}
            padding={4}
          >
            <Image
              src={require("../../assets/logo.svg").default}
              w={88}
              h={76}
            />
            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
            >
              KIDSWEAR
            </Text>
            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
            >
              COLLECTIVE
            </Text>

            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
              marginBlock={8}
            >
              Business Team
            </Text>

            <Text
              color={"#FFFFFF"}
              fontFamily={"PlusJakartaSansSemiBold"}
              textTransform={"uppercase"}
              fontSize={"24px"}
              marginBottom={"16px"}
            >
              CREATE NEW PASSWORD
            </Text>

            <Flex flexDirection={"column"} gap={"16px"} mb={"16px"} w={"100%"}>
              <FormikInput
                name="newPassword"
                label="New Password"
                labelColor={"white"}
                color="#fff"
                placeholder="Enter your new password"
                isPassword={true}
                formik={formik}
              />
              <FormikInput
                name="confirmPassword"
                label="Confirm New Password"
                labelColor={"white"}
                color="#fff"
                placeholder="Re-enter your new password"
                isPassword={true}
                formik={formik}
              />
            </Flex>
            <Button
              onClick={formik.handleSubmit}
              isDisabled={
                createNewPasswordMutation.isLoading ||
                !formik.values.newPassword ||
                !formik.values.confirmPassword
              }
              w={"100%"}
              borderRadius={8}
              bg={"primary.500"}
              color={"#FFFFFF"}
              fontSize={14}
              fontFamily={"PlusJakartaSansMedium"}
              textTransform={"uppercase"}
              _hover={{
                bg: "#273979",
                color: "#737373",
              }}
              _disabled={{
                bg: "transparent",
                border: "1px solid white",
                cursor: "initial",
              }}
            >
              {createNewPasswordMutation.isLoading ? <Spinner /> : "CONTINUE"}
            </Button>
          </Flex>
        </Center>
      </Box>
    </Flex>
  );
};

export default CreateNewPassword;
